<template>
  <div>
    <div
      class="overlay"
      v-if="opened"
    >
      <div class="notification">
        <b-alert
          :variant="variant"
          class="m-0"
          show
          dismissible
          @dismissed="close"
        >
          <h4 class="alert-heading">{{notification.title || 'Comunicazione'}}</h4>
          <p>{{notification.message}}</p>
          <div class="text-right py-2">
            <template v-if="notification.type==='confirm'">
              <a
                href="#"
                class="alert-link text-uppercase text-success mr-3"
                @click="okClick"
              >Conferma</a>
              <a
                href="#"
                class="alert-link text-uppercase text-sceondary"
                @click="cancelClick"
              >Annulla</a>
            </template>
            <a
              v-else
              href="#"
              class="alert-link text-uppercase text-sceondary"
              @click="closeClick"
            >Chiudi</a>
          </div>
        </b-alert>
      </div>
    </div>
  </div>
</template>

<script>

const isPromise = (obj) => {
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function'
}

export default {
  name: 'NotificationAlert',

  data () {
    return {
      opened: false
    }
  },

  watch: {
    '$store.state.ui.notification' (newVal) {
      this.opened = !!newVal.message
    }
  },

  computed: {
    notification () {
      return this.$store.state.ui.notification
    },
    variant () {
      let v = this.notification.type || 'success'
      return v === 'confirm' ? '' : v
    }
  },
  methods: {

    close () {
      this.$store.commit('ui/clearNotification')
    },

    okClick () {
      let handler = this.notification.okHandler
      this.close()
      if (handler) {
        if (isPromise(handler)) handler.resolve()
        else handler()
      }
    },

    cancelClick () {
      let handler = this.notification.cancelHandler
      this.close()
      if (handler) {
        if (isPromise(handler)) handler.resolve()
        else handler()
      }
    },

    closeClick () {
      let handler = this.notification.closeHandler
      this.close()
      if (handler) {
        if (isPromise(handler)) handler.resolve()
        else handler()
      }
    }
  }

}
</script>

<style lang="stylus" scoped>
.overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}

.notification {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  max-width: 50vw;
  background: #fff;
}
</style>
